
  import "./scss/Accordion.scss"
  import { computed, defineComponent, ref } from "vue"
  import { useStore } from "vuex"
  import Accordion from "./Accordion.vue"

  // isRotate - true - en | !isRotate - false - ru
  export default defineComponent({
    name: "AccordionWrapper",
    components: { Accordion },
    setup() {
      const isVolume = ref(true)
      const setVolume = () => isVolume.value = !isVolume.value
      const store = useStore()

      const currentWords = computed(() => store.getters.currentWords)

      return { isVolume, setVolume, currentWords }
    }
  })
